import FilterToolbar from "./FilterToolbar";
import { reducer, mapStateToProps, mapDispatchToProps } from "./FilterToolbar.state";

FilterToolbar.reducer = reducer;
FilterToolbar.mapStateToProps = mapStateToProps;
FilterToolbar.mapDispatchToProps = mapDispatchToProps;

export default FilterToolbar;
